import React from 'react'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'
import PageWrapupSkeleton from 'src/ui/PageWrapup/PageWrapupSkeleton'

const LevelWrapupPlaceholder: React.FC = () => {
  return (
    <PageWrapupSkeleton
      contentSection={
        <>
          <LoadingBox height={168} />
          <LoadingBox height={200} />
        </>
      }
    />
  )
}

export default LevelWrapupPlaceholder
